import React, { Component } from 'react'
import TextField from 'material-ui/TextField'
import { FormattedMessage } from 'react-intl'
import RaisedButton from 'material-ui/RaisedButton'

import { getToken } from '../../lib'

export default class ResetForm extends Component {
  state = {
    rpasswordError: null,
    passwordError: null,
    hasErrors: null
  }

  handleSubmit = e => {
    e.preventDefault()
    const autToken = getToken()
    const {email, token} = this.props.queries
    let post = true
    let passwordsMatch = false
    let {password, rpassword} = this.refs
    password = password.getValue()
    rpassword = rpassword.getValue()

    if (!password) {
      this.setState({
        passwordError: <FormattedMessage id="login.requiredField"/>,
        hasErrors: true
      })
      post = false
    } else if (password.length < 8) {
      this.setState({
        passwordError: <FormattedMessage id="signUp.passwordError.short"/>,
        hasErrors: true
      })
      post = false
    } else if (
      password.search(/\d/) === -1 ||
      password.search(/[a-zA-Z]/) === -1
    ) {
      this.setState({
        passwordError: (
          <FormattedMessage id="signUp.passwordError.alphaNumeric"/>
        ),
        hasErrors: true
      })
      post = false
    } else if (password !== rpassword) {
      this.setState({
        passwordError: <FormattedMessage id="signUp.passwordError.dontMatch"/>,
        rpasswordError: (
          <FormattedMessage id="signUp.passwordError.dontMatch"/>
        ),
        hasErrors: true
      })
      post = false
    } else {
      this.setState({passwordError: null})
      passwordsMatch = true
    }

    if (!rpassword) {
      this.setState({
        rpasswordError: <FormattedMessage id="login.requiredField"/>,
        hasErrors: true
      })
      post = false
    }

    if (passwordsMatch) {
      this.setState({rpasswordError: null})
    }

    if (post) {
      this.setState({hasErrors: false})
      this.props.changePassword(autToken, email, password, token)
    }
  }

  render() {
    return (
      <form autoComplete="off" onSubmit={this.handleSubmit}>
        <div style={{fontSize: 20, color: '#6B7C93'}}>
          Reset your password for {this.props.queries.email}
        </div>
        <div className="mb4">
          <input style={{display: 'none'}} type="password" name="username"/>
          <input style={{display: 'none'}} type="password" name="password"/>
          <TextField
            hintText="********"
            floatingLabelText={<FormattedMessage id="login.passwordLable"/>}
            type="password"
            fullWidth
            name="password"
            autoComplete="off"
            ref="password"
            errorText={this.state.passwordError}
          />
          <TextField
            hintText="********"
            floatingLabelText={
              <FormattedMessage id="signUp.confirmPasswordLabel"/>
            }
            type="password"
            fullWidth
            ref="rpassword"
            errorText={this.state.rpasswordError}
          />
          <div className="flex justify-end mt3">
            <RaisedButton
              type="submit"
              label="save"
              labelStyle={{color: '#ffffff'}}
              backgroundColor="#45CE90"
            />
          </div>
        </div>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// src/components/ResetForm/ResetForm.js